import type { IDateValue, ISocialLink } from './common';

// ----------------------------------------------------------------------

export type IUserTableFilters = {
  name: string;
  role: string[];
  status: string;
};

// =========================
// CLIENTI
// =========================

export type IClienteData = {
  id?: number;
  idUser?: number;
  dataDiNascita?: string | null;
  sesso?: number;
  telefono?: string;
  codiceFiscale?: string;
  consulenteRiferimento?: string;
  nomeComunicazioni?: string;
  firma?: string;
  indirizzo?: string;
  citta?: string;
  provincia?: string;
  cap?: string;
  personeACarico?: number;
  capitaleDaInvestire?: string | null;
  importoPAC?: string | null;
  periodicita?: string;
  canaleProvenienza?: string;
  tipoPortafoglio?: string;
  tipoCliente?: string;
  note?: string;
  fondoPensione?: string;
  inquadramento?: string;
  professione?: string;
  denaroAltrove?: string | null;
  noteDenaroAltrove?: string;
  dataPrimoContatto?: string | null;
  bancaProvenienza?: string;
  tipoRolling?: string;
  fineRolling?: string | null;
  periodicitaRolling?: string;
  esigenzeParticolari?: string;
  referenziatoDa?: string;
  societa?: string;
  dataInizioRapporto?: string | null;
  annoDiPensionamento?: string;
  proporzioneSulPatrimonioTotale?: string;
  massimaPerditaTollerabile?: string;
  contributoVolontarioFondoPensione?: string | null;
  ral?: string | null;
  capitaleFondoEmergenza?: string | null;
  strumentoFondoEmergenza?: string;
  dataDiScadenzaFondoEmergenza?: string | null;
  iscrittoDaAlmeno2Anni?: boolean;
  titoloDiStudio?: string;
  indirizzoAzienda?: string;
  versamentiAutomatici?: boolean;
  campiExtra?: ICampoExtra[];
  createdAt?: string;
  updatedAt?: string;
};

// =========================
// CONSULENTI
// =========================

export type IDatiConsulente = {
  id?: number;
  idUser?: number;
  dataDiNascita?: string | null;
  sesso?: number;
  telefono?: string;
  codiceFiscale?: string;
  indirizzo?: string;
  citta?: string;
  provincia?: string;
  cap?: string;
  sdi?: string;
  vat?: string;
  pec?: string;
  createdAt?: string;
  updatedAt?: string;
};

export enum CampoExtraType {
  String = 'String',
  Int = 'Int',
  Boolean = 'Boolean',
}

export type ICampoExtra = {
  id?: string;
  type: CampoExtraType;
  name: string;
  required: boolean;
  value?: any;
};

export type ICampoExtraTableFilters = {
  name: string;
  type: string[];
  required: string;
};

export enum RoleType {
  Amministratore = 'Amministratore',
  Backoffice = 'Backoffice',
  User = 'User',
  Consulente = 'Consulente',
  /** non ancora consulente: segue il percorso di avviamento (vista Beginner) */
  Beginner = 'Beginner',
}

export type IUserItem = {
  id?: number;
  avatarPath?: string;
  email: string;
  active: number;
  name: string;
  lastname: string;
  password?: string;
  role: RoleType;
  datiCliente: IClienteData;
  /** strumenti riservati a un solo consulente, decisi dal server (vedi RoleGuard) */
  strumentiRiservati?: string[];
  /** risorse ("menu:articoli", "questionario:12"...) che le regole di visibilita' lasciano vedere a un Consulente; il server le ricontrolla a ogni richiesta */
  risorseVisibili?: string[];
};

export type IConsulenteItem = {
  id?: number;
  avatarPath?: string;
  email: string;
  active: number;
  name: string;
  lastname: string;
  password?: string;
  role: RoleType;
  datiConsulente: IDatiConsulente;
  /** strumenti riservati a un solo consulente, decisi dal server (vedi RoleGuard) */
  strumentiRiservati?: string[];
  /** risorse ("menu:articoli", "questionario:12"...) che le regole di visibilita' lasciano vedere a un Consulente; il server le ricontrolla a ogni richiesta */
  risorseVisibili?: string[];
};
